var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn mx-auto",class:_vm.buttonClass,attrs:{"disabled":_vm.buttonDisabled || _vm.isLoading},on:{"click":function($event){return _vm.serverPrint()}}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }